import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const cache = {};

export const useList = (params, enabled) => {
  const key = JSON.stringify(params);
  const [list, setList] = useState(cache[key] || []);
  useEffect(() => {
    if (!enabled) { setList([]); return; }
    if (cache[key]) { setList(cache[key]); return; }
    let live = true;
    api.get("/address/regions", { params }).then((r) => { cache[key] = r.data; if (live) setList(r.data); }).catch(() => { if (live) setList([]); });
    return () => { live = false; };
  }, [key, enabled]); // eslint-disable-line react-hooks/exhaustive-deps
  return list;
};

export const Select = ({ id, label, value, options, onChange, placeholder, disabled, required }) => {
  const opts = value && !options.includes(value) ? [value, ...options] : options;
  return (
    <div className="space-y-1.5">
      <Label htmlFor={id}>{label}</Label>
      <select id={id} data-testid={`${id}-select`} value={value} required={required} disabled={disabled} onChange={(e) => onChange(e.target.value)}
        className="h-9 w-full rounded-md border border-input bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-amber-700/30 disabled:bg-stone-100 disabled:text-stone-400">
        <option value="">{placeholder}</option>
        {opts.map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
    </div>
  );
};

export const RegionFields = ({ value, onChange }) => {
  const { province, city, district, village, postal_code } = value;
  const provinces = useList({}, true);
  const cities = useList({ province }, !!province);
  const districts = useList({ province, city }, !!(province && city));
  const villages = useList({ province, city, district }, !!(province && city && district));
  const villageNames = villages.map((v) => v.village);
  const pickVillage = (v) => onChange({ village: v, postal_code: villages.find((x) => x.village === v)?.postal_code || "" });
  useEffect(() => {
    if (villages.length === 1 && !village) pickVillage(villages[0].village);
    else if (village && !postal_code) { const m = villages.find((x) => x.village === village); if (m) onChange({ postal_code: m.postal_code }); }
  }, [villages]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <>
      <Select id="recipient-province" label="Provinsi" value={province} options={provinces} placeholder="Pilih provinsi"
        onChange={(v) => onChange({ province: v, city: "", district: "", village: "", postal_code: "" })} />
      <Select id="recipient-city" label="Kota / Kabupaten" value={city} options={cities} required disabled={!province} placeholder="Pilih kota / kabupaten"
        onChange={(v) => onChange({ city: v, district: "", village: "", postal_code: "" })} />
      <Select id="recipient-district" label="Kecamatan" value={district} options={districts} disabled={!city} placeholder={city ? "Pilih kecamatan" : "Pilih kota dulu"}
        onChange={(v) => onChange({ district: v, village: "", postal_code: "" })} />
      <Select id="recipient-village" label="Kelurahan / Desa" value={village} options={villageNames} disabled={!district} placeholder={district ? "Pilih kelurahan / desa" : "Pilih kecamatan dulu"}
        onChange={pickVillage} />
      <div className="space-y-1.5">
        <Label htmlFor="r-postal">Kode pos</Label>
        <Input id="r-postal" data-testid="recipient-postal-input" inputMode="numeric" value={postal_code} onChange={(e) => onChange({ postal_code: e.target.value })} />
      </div>
    </>
  );
};
